import { useState } from 'react';
import './Profile.css';

function Profile({ onBack, user }) {
  const [formData, setFormData] = useState({
    fullName: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName || '',
    email: user.email || '',
    phone: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [avatarLetter, setAvatarLetter] = useState((user.firstName || 'U').charAt(0).toUpperCase());

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === 'fullName') {
      setAvatarLetter(value.trim().charAt(0).toUpperCase() || 'T');
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    // placeholder — hook up to backend later
  };

  return (
    <div className="profile">
      <div className="profile-header">
        <button className="profile-back" onClick={onBack}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M11 3L4 9l7 6" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Back to Dashboard
        </button>
      </div>

      <form className="profile-form" onSubmit={handleSave}>
        {/* Avatar + name summary */}
        <div className="profile-card">
          <div className="profile-avatar-row">
            <div className="profile-avatar">{avatarLetter}</div>
            <div className="profile-avatar-info">
              <span className="profile-avatar-name">{formData.fullName || 'Name'}</span>
              <span className="profile-avatar-email">{formData.email}</span>
            </div>
          </div>
        </div>

        {/* Personal info */}
        <div className="profile-card">
          <h2 className="profile-section-title">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="9" cy="6" r="3" stroke="#1a1a2e" strokeWidth="1.5" />
              <path d="M3 16c0-3.31 2.69-6 6-6s6 2.69 6 6" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            Personal Information
          </h2>

          <div className="profile-field">
            <label>Full Name</label>
            <input
              type="text"
              value={formData.fullName}
              placeholder="John Doe"
              onChange={(e) => handleChange('fullName', e.target.value)}
            />
          </div>

          <div className="profile-field">
            <label>Email Address</label>
            <input
              type="email"
              value={formData.email}
              placeholder="you@example.com"
              onChange={(e) => handleChange('email', e.target.value)}
            />
          </div>

          <div className="profile-field">
            <label>Phone Number (optional)</label>
            <input
              type="tel"
              value={formData.phone}
              placeholder="+91 XXXXXXXXXX"
              onChange={(e) => handleChange('phone', e.target.value)}
            />
          </div>
        </div>

        {/* Change password */}
        <div className="profile-card">
          <h2 className="profile-section-title">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <rect x="2" y="8" width="14" height="8" rx="2" stroke="#1a1a2e" strokeWidth="1.5" />
              <path d="M5 8V6a4 4 0 018 0v2" stroke="#1a1a2e" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            Change Password
          </h2>

          <div className="profile-field">
            <label>Current Password</label>
            <input
              type="password"
              value={formData.currentPassword}
              placeholder="••••••••"
              onChange={(e) => handleChange('currentPassword', e.target.value)}
            />
          </div>

          <div className="profile-field">
            <label>New Password</label>
            <input
              type="password"
              value={formData.newPassword}
              placeholder="••••••••"
              onChange={(e) => handleChange('newPassword', e.target.value)}
            />
          </div>

          <div className="profile-field">
            <label>Confirm New Password</label>
            <input
              type="password"
              value={formData.confirmPassword}
              placeholder="••••••••"
              onChange={(e) => handleChange('confirmPassword', e.target.value)}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="profile-actions">
          <button type="button" className="profile-cancel" onClick={onBack}>Cancel</button>
          <button type="submit" className="profile-save">Save Changes</button>
        </div>
      </form>
    </div>
  );
}

export default Profile;
